import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'jsx/hooks/useTranslation';

const PageNavigation = ({ products }) => {
  const { t } = useTranslation();

  if (!products || products.length === 0) return null;
  return (
    <div className="page-nav no-print">
      <ul className="main-nav">
        {products.map((item, index) => {
          if (!item.showInNavigation) return null;
          return (
            <li key={index}>
              <NavLink exact={item.url === '/' || item.exact} activeClassName="selected" to={item.url}>
                {item.productID
                  ? t(`product_name_${item.productID}${item.subtreeID ? '_' + item.subtreeID : ''}`)
                  : item.label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PageNavigation;
